const Steps = {
  props: [
    {
      name: 'active',
      default: '',
      type: 'number',
      desc: '当前激活步骤'
    }
  ]
}

const Step = {
  props: [
    {
      name: 'status',
      default: '',
      type: 'finish | process | error | wait | reject',
      desc: '当前步骤的状态'
    },
    {
      name: 'title',
      default: '',
      type: 'string',
      desc: '当前步骤的标题'
    }
  ],
  slots: [
    {
      name: 'default',
      desc: '描述文字'
    }
  ]
}

export default [
  {
    name: 'Steps API',
    content: Steps
  },
  {
    name: 'Step API',
    content: Step
  }
]
